import axios from 'axios';
import type { TenantInfo, TenantUser } from '../stores/auth.tenant';

export interface DelegatedSession {
  jwt: string;
  user: TenantUser;
  tenant: TenantInfo;
  has_seat: boolean;
}

const api = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL || '/api', timeout: 15_000 });

export function exchangeDelegatedEntry(ticket: string): Promise<DelegatedSession> {
  return api.post<DelegatedSession>('/tenant/admin/delegated-entry/exchange', { ticket }).then(r => r.data);
}
